import { render, staticRenderFns } from "./LabelModal.vue?vue&type=template&id=22915fea&scoped=true&"
import script from "./LabelModal.vue?vue&type=script&lang=js&"
export * from "./LabelModal.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal.vue?vue&type=style&index=0&id=22915fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22915fea",
  null
  
)

export default component.exports